import React from 'react';
import IndustryInfoLayout from '../components/fieldsInfo/fieldsInfoLayout';

const FieldsInfoPage = () => {
	return <IndustryInfoLayout/>;
};


export default FieldsInfoPage;